import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { getRegistrationComplete } from "../../api/registration";
import { getApplicationSettings } from "../../api/applicationSettings";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import Moment from "react-moment";
import Page from "../Page";
import Box from "../Box";
import LoadingContent from "../LoadingContent";
import ProofOfStudiesUpload from "../ProofOfStudiesUpload";
import queryString from "query-string";
import Cookies from "js-cookie";
import * as config from "../../config";

class RegistrationCompletePage extends PureComponent {
  static propTypes = {
    me: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      applicationSettings: [{}],
      registrationComplete: {
        event: {},
      },
      paymentProcessed:
        queryString.parse(window.location.search).paymentProcessed === "true",
      };        
  }

  componentDidMount = () => {
    this._getApplicationSettings();
    this._getRegistrationComplete();
    //adding social sharing links via AddThis
    // const s = document.createElement("script");
    // s.type = "text/javascript";
    // s.src = //   "https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5bd06e4c4778b351";
    // document.body.appendChild(s);
  };

  _getRegistrationComplete = () => {
    this.setState({ loading: true });

    getRegistrationComplete().then((response) => {
      this.setState({ registrationComplete: response, loading: false });

      if (this.state.paymentProcessed) {
        Cookies.set("refreshWwwUser", "true", {
          path: "/",
          domain: config.cookieDomain,
          sameSite: "lax",
          secure: true,
        });
      }
    });
  };

  _getApplicationSettings = () => {

    console.log("_getApplicationSettings");

    this.setState({ loading: true });    
    getApplicationSettings().then((response) => {
      this.setState({ applicationSettings: JSON.parse(response), loading: false });
    })    
  }

  _goToSessionsPage = (e) => {
    toast.dismiss();
    this.props.history.push("/sessions");
  };

  _goToSchedulePage = (e) => {
    toast.dismiss();
    this.props.history.push("/schedule");
  };

  _goToAanpConnect = (e) => {
    toast.dismiss();
    window.location.href = "https://aanpconnect.aanp.org";
  };

  _goToConferencePage = value => () => {
    toast.dismiss();
    window.open(value, "_blank");
  };

  _goToOrderHistory = (e) => {
    toast.dismiss();
    window.location.href = config.orderHistoryUrl;
  };

  _proofOfStudiesUploaded = () => {
    this.setState((prevState) => ({
      ...prevState,
      registrationComplete: {
        ...prevState.registrationComplete,
        studentApprovalStatus: "Pending",
      },
    }));
  };

  render() {
    if (this.state.loading) {
      return <LoadingContent />;
    }

    let { registrationComplete } = this.state;

    return (
      <Page title="Conference Registration">
        {registrationComplete.isStudent &&
          registrationComplete.studentApprovalStatus === "Not Uploaded" && (
            <div className="warning-box mt-4 p-4">
              <div className="row">
                <div className="col-lg-8">
                  <h2>Proof of Student Status</h2>
                  <p className="mt-2 text-bold">
                    You registered as a student, and must provide proof of
                    current student registration.
                  </p>
                  <p className="mt-2">
                    You must upload proof of your student status at least two
                    weeks prior to conference.
                  </p>
                  <p className="mt-3 mb-2">
                    Status:
                    <span className="red-text ml-2">
                      <b>{registrationComplete.studentApprovalStatus}</b>
                    </span>
                  </p>
                </div>
                <div className="col-lg-4">
                  <ProofOfStudiesUpload
                    onUploaded={this._proofOfStudiesUploaded}
                    enabled={true}
                  />
                </div>
              </div>
            </div>
          )}

        {registrationComplete.hasApprovedWaitlistItems && (
          <div className="waitlist-approved-container mt-4 p-4">
            <div className="row">
              <div className="col-8">
                <div className="header">
                  You Have Been Approved To Attend One Or More Sessions
                </div>
              </div>
              <div className="col-4">
                <button
                  className="btn btn-block btn-green"
                  onClick={(e) => this._goToSessionsPage()}
                >
                  Change Your Schedule
                </button>
              </div>
            </div>
          </div>
        )}

        <div className="info-box mt-4 col-lg-12 col-centered p-4" style={{display: registrationComplete.event.eventTitle ? "block" : "none" }}>
          <div className="row">
            <div className="col-lg-12 mb-6 mb-lg-0">
              {this.state.paymentProcessed && (
                <h2 className="blue-text">
                  Thank you for registering for the {" "}
                  {registrationComplete.event.eventTitle}!
                </h2>
              )}
              {!this.state.paymentProcessed && (
                <h2 className="blue-text">
                  You've already registered for the {" "}
                  {registrationComplete.event.eventTitle}!
                </h2>
              )}
            </div>
            <div className="col-lg-12 mb-6 mb-lg-0">
                Watch for additional emails with important updates to keep you informed. The event begins{" "}
                <strong>
                    <Moment format="MMMM DD">
                        {registrationComplete.event.startDate}
                    </Moment>
                </strong>
                {", "}
                so mark your calendar!
            </div>
          </div>
          <br />
        {Date() >= new Date(registrationComplete.event.startDate) && !registrationComplete.event.HasVirtualSite && (
            <div className="row">
                <div className="col-lg-12 mb-3 mb-lg-0">
                    <button
                        type="button"
                        className="btn btn-primary btn-block"                        
                        onClick={(e) => this._goToAanpConnect()}                        
                    >
                        Connect to the {registrationComplete.event.eventTitle}
                    </button>
                </div>
            </div>
        )}
        {Date() >= new Date(registrationComplete.event.startDate) && registrationComplete.event.HasVirtualSite && (
            <div className="row">
                <div className="col-lg-12 mb-3 mb-lg-0">
                    <button
                        type="button"
                        className="btn btn-primary btn-block"
                        onClick={this._goToConferencePage(registrationComplete.event.virtualSiteUrl)}
                    >
                        Connect to the {registrationComplete.event.eventTitle}
                    </button>
                </div>
            </div>
        )}
        <br />
          <div className="row">
            <div className="col-lg-12 mb-3 mb-lg-0">
              <button
                type="button"
                className="btn btn-primary btn-block"
                onClick={(e) => this._goToOrderHistory()}
              >
                View Your Order History and Receipts
              </button> 
            </div>
          </div>          
          {registrationComplete.event.sessionSelection && registrationComplete.canRegisterForSessions
            && (<div className="row">
                  <div className="col-lg-6" style={{display:"none"}}>
                  {registrationComplete.event.sessionSelection &&
                    !registrationComplete.canRegisterForSessions && (
                      <p>
                        Registering early was a smart idea. When session selection
                        is available, you'll be among the first to be notified.
                      </p>
                    )}
                  {registrationComplete.event.sessionSelection &&
                    registrationComplete.canRegisterForSessions && (
                      <div>
                        <p className="text-bold">Select Your Sessions Before:</p>
                        <p className="text-bold">
                          {registrationComplete.scheduleChangeEndDate}
                        </p>
                        <p className="mt-2">
                          After this date, no changes can be made to your schedule.
                        </p>
                      </div>
                    )}
                </div>
                <div className="col-lg-12">
                  <div className="mt-3">
                    <hr className="mt-2" />
                    <p className="text-bold">Here’s What to Do Next:</p>
                    <ul className="benefits-list">
                      <li>
                        <a href= {config.rootUrl + "/sessions"}>
                          Select sessions tailored to your interests.
                        </a>
                      </li>
                      <li>
                        <a href={config.conferenceGuideUrl}>
                          Learn more about conference.
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="mt-3">
                    {registrationComplete.allowScheduleChanges && (
                      <div className="row">
                        <div className="col-lg-6 pr-lg-0">
                          <button
                            type="button"
                            className="btn btn-primary btn-block"
                            onClick={(e) => this._goToSchedulePage(e)}
                          >
                            View Your Schedule
                          </button>
                        </div>
                        <div className="col-lg-6 mt-lg-0 mt-2">
                          <button
                            type="button"
                            className="btn btn-primary btn-block"
                            onClick={(e) => this._goToSessionsPage(e)}
                          >
                            Change Your Schedule
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
          </div>)}          
        </div>
        {registrationComplete.event.conferenceType === "Virtual" && (
          <Box title="Conference Details">
            <div className="row">
              <div className="col-12">
                  <div>
                    <strong>Thank you for registering for the {" "}
                    <a href={this.state.applicationSettings["ondemandConference"]}
                    target="_blank" 
                    rel="noopener noreferrer">{registrationComplete.event.eventTitle}</a>{"! "}</strong>
                    Please take a few minutes to read the information below, so you will be prepared to make the most of 
                    your American Association of Nurse Practitioners® (AANP) conference experience.
                  </div>
              </div>
            </div>
            <br></br>
            <div className="row">
              <div className="col-12">
                  <div className="header">
                    <strong>Stay Connected!</strong>
                  </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
              <ul className="taskList">
                  {config.conferenceGuideUrl.length > 0 && (
                    <li>
                    View the{" "}
                    <a
                      href={config.conferenceGuideUrl} target="_blank" rel="noreferrer"
                    >
                      {registrationComplete.event.eventTitle}
                    </a>{" "}
                      event page to help you navigate the conference and plan your learning schedule.
                  </li>
                  )}
                  <li>
                    Follow the American Association of Nurse Practitioners&#174;
                    (AANP) on social media to connect with other nurse
                    practitioners (NPs) and industry professionals, join the
                    #AANP26 conversation, stay current with the latest
                    health care news and receive conference announcements.
                    <ul>
                      <li>
                        <a
                          href="https://www.facebook.com/AmericanAssociationofNPs"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Facebook
                        </a>{" "}
                        — AmericanAssociationofNPs.
                      </li>
                      <li>
                        <a
                          href="https://x.com/aanp_news"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          X
                        </a>{" "}
                        — @AANP_News.
                      </li>
                      <li>
                        <a
                          href="https://www.instagram.com/aanp_news/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Instagram
                        </a>{" "}
                        — @AANP_News.
                      </li>
                      <li>
                        <a
                          href="https://www.linkedin.com/company/272713/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          LinkedIn
                        </a>{" "}
                        — American Association of Nurse Practitioners.
                      </li>
                    </ul>
                  </li>
                  <li>
                    Mark your calendar for the{" "}
                    <strong>
                      <Moment format="LL">
                        {registrationComplete.event.startDate}
                      </Moment>
                    </strong>
                    {", "}
                    launch date, and be sure to share a photo of your conference
                    experience using the #AANP26 hashtag on social media.
                  </li>
                </ul>
              </div>
            </div>
            <div className="row" style={{ display: "none" }}>
              <div className="col-12">
                <div className="header">
                  <strong>System Check:</strong>
                </div>
              </div>
              <div className="col-12">
                <p>
                  Use the link below to test your system in advance on the
                  device you will use to login to the virtual environment.
                </p>
                <p>
                  <a
                    href="https://support.goto.com/webinar/system-check-attendee"
                    target="_blank"
                    rel="noopener noreferrer" 
                  >
                    Perform System Test
                  </a>
                </p>
              </div>
            </div>
              <div className="row" style={{ display: "inline-block" }}>
                <div className="col-12">
                  <div className="header">
                    <strong>Minimum System Requirements</strong>
                  </div>
                </div>
                <div className="col-12">
                  <p style={{fontSize: "1rem"}}>
                    For the best conference experience, it is recommended that
                    you:
                  </p>
                    <ul className="taskList">
                      <li>
                        Use Google Chrome, Mozilla Firefox, Microsoft EDGE or
                        Apple Safari (for Mac products) as your web browser.
                      </li>
                      <li>
                        Ensure that your operating system is Windows 8 or higher
                        for personal computers or Mac OS X 10.8 or higher.
                      </li>
                      <li>Use a minimum screen resolution of 1024 x 768.</li>
                      <li>
                        Have an internet connection with download speed
                        of 3 megabits per second (Mbps) or greater.
                      </li>
                      <li>Disable browser pop-up blockers.</li>
                    </ul>
                </div>
              </div>
          </Box>
        )}
        {registrationComplete.event.conferenceType !== "Virtual"         
        && (
          <Box title="Conference Information" className="box-conferenceInfo">
            <div className="row">          
              <div className="col-lg pr-lg-1 mb-2 mb-lg-0">
                <div className="conference-description"
                  dangerouslySetInnerHTML={{ __html: registrationComplete.event.housingInfo }} />
              </div>
            </div>
          </Box>          
        )}
        <Box title="More" className="box-more">
          <div className="row more-links">
            {registrationComplete.mobileUrl && (
              <div className="col-lg">
                <div className="text-bold">Mobile App</div>
                <p className="info">
                  The AANP Mobile App provides you with quick access to your
                  schedule, handouts, maps, and evaluations, right at your
                  fingertips.
                </p>
                <a
                  className="btn btn-primary btn-block mt-4"
                  href={registrationComplete.mobileUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Download The AANP App
                </a>
              </div>
            )}

            {registrationComplete.handoutsAvailable && (
              <div className="col-lg mt-2 mt-lg-0">
                <div className="divider d-lg-none" />
                <div className="text-bold">Session Handouts</div>
                <p className="info">
                  Prepare yourself! View and download handouts to get the most
                  out of your sessions.
                </p>
                <a
                  className="btn btn-primary btn-block mt-4"
                  href={registrationComplete.handoutsUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Session Handouts
                </a>
              </div>
            )}
            {registrationComplete.hasStarted && (
              <div className="col-lg mt-2 mt-lg-0">
                <div className="divider d-lg-none" />
                <div className="text-bold">Evaluations</div>
                <p className="info">
                  Completing your evaluations (including the General Conference
                  Evaluation) allows you to obtain your CE and Pharm Hours.
                </p>
                <a
                  className="btn btn-primary btn-block mt-4"
                  href={registrationComplete.evalUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Evaluations
                </a>
              </div>
            )}
          </div>
        </Box>
        {/* <Box title="Refund and Cancellation Policy" className="conference-info">
          <div
            className="conference-description"
            dangerouslySetInnerHTML={{
              __html: registrationComplete.event.cancellationAndRefundPolicy,
            }}
          />
        </Box> */}
      </Page>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    me: state.account.me,
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    null
  )(RegistrationCompletePage)
);